import {Component, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs";
import {AuthenticationService} from "../services/authentication.service";
import {UserDataStoreService} from "../services/user-data-store.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ParticipantRoleAndPermissionsViewModel} from "../models/participant-role-and-permissions-view-model";
import {RoleViewComponent} from "./role-view/role-view.component";
import {DataTableDirective} from "angular-datatables";
import { PermissionEnum } from '../services/guards/permissions';
import { ToastrService } from 'ngx-toastr';
import { SearchFilterModel } from '../models/search-filter-model';


@Component({
  selector: 'app-roles-management',
  templateUrl: './roles-management.component.html',
  styleUrls: ['./roles-management.component.scss']
})
export class RolesManagementComponent implements OnInit {

  public dtOptions: DataTables.Settings = {};
  public rolesAndPermissions: ParticipantRoleAndPermissionsViewModel[] = [];
  public dtTrigger: Subject<boolean> = new Subject();
  public canEdit: boolean;
  public canAdd: boolean;

  public filter: SearchFilterModel = {
    search: '',
    take: 10,
    skip: 0,
    orderBy: null,
    orderDirection: 'ASC'
  };

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  constructor(private _userDataStore: UserDataStoreService, private _authenticationService: AuthenticationService, private _modalService: NgbModal, private _toastService: ToastrService) {

    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditRole], []);
    this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddRole], []);
  }

  ngOnInit() {
    const that = this;

    this.dtOptions = {
      pageLength: this.filter.take,
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      ajax: async (dataTablesParameters: any, callback) => {
        this.filter.search = dataTablesParameters.search.value;
        this.filter.take = dataTablesParameters.length;
        this.filter.skip = dataTablesParameters.start;
        this.filter.orderDirection = dataTablesParameters.order[0].dir;
        this.filter.orderBy = dataTablesParameters.columns[dataTablesParameters.order[0].column].data;
        const result = await this._authenticationService.GetParticipantRolesAndPermissions(this.filter);
        this.rolesAndPermissions = result.response;
        callback({
          recordsTotal: result.total,
          recordsFiltered: result.total,
          data: []
        });
      },
      responsive: true,
      columns: [
        { name: 'Role', data: 'Name' },
        { name: 'Description', data: 'Description' },
        { name:'Actions', data: 'actions', orderable: false }
      ]
    };
  }

  public async ngAfterViewInit(): Promise<void> {
    await this.init();
  }

  private async init(): Promise<void>{
    this.dtTrigger.next();
  }

  private resetDatatable(): void {
    this.rolesAndPermissions = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public async addRole(): Promise<void>{
    if (!this.canAdd) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      const modalRef = this._modalService.open(RoleViewComponent, {
        windowClass: 'modal-fade-in',
        centered: false,
        size: 'xl',
        backdrop: 'static'
      });
      await modalRef.result;
      this.resetDatatable();
    }

  }

  public async editRole(roleAndPermissions: ParticipantRoleAndPermissionsViewModel): Promise<void>{
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      const modalRef = this._modalService.open(RoleViewComponent, {
        windowClass: 'modal-fade-in',
        centered: false,
        size: 'xl',
        backdrop: 'static'
      });
      modalRef.componentInstance.roleAndPermissionsViewModel = roleAndPermissions;

      await modalRef.result;
      this.resetDatatable();
    }

  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
